//constants
import {
	DELETE_UPPER,
	PATRON_DETAILS,
	TICKETS_TIERS,
	ALL_TICKETS_TIERS,
	CHECK_IN,
	PENDING,
	STATUS,
	VIP_STATUS,
	SPECIAL_MEAL,
	ALL_ATTENDEES,
	CHECKED_IN,
	PAID,
	TABLE_DETAILS,
	COLLECT_PAYMENT,
	SEND_PAYMENT_LINK,
	NOT_CHECKED_IN,
	PAY_STATUS,
} from '@/utils/constants';
//enum
import {TABLE_VIP_STATUS, TABLE_SPECIAL_MEAL, PAYMENT_STATUS} from '@/utils/enums/tables.enum';
//types
import {IFilterGroup, IOrganizationTicketsTiers} from '@/utils/types';

export const tableAttendeesMenuContent = [
	PATRON_DETAILS,
	TABLE_DETAILS,
	COLLECT_PAYMENT,
	SEND_PAYMENT_LINK,
	CHECK_IN,
	DELETE_UPPER,
];

interface IFilterValues {
	sortColumn: string;
	isOrderDesc: boolean;
	isOnlyVip: boolean;
	isSpecialMeal: boolean;
	ticketTiersId: null;
	attendeeStatus?: string;
	attendeePaidStatus?: PAYMENT_STATUS;
}

export const attendeesDefaultFilter: IFilterValues = {
	sortColumn: '',
	isOrderDesc: false,
	isOnlyVip: false,
	isSpecialMeal: false,
	ticketTiersId: null,
	attendeePaidStatus: PAYMENT_STATUS.ALL,
};

export const attendeesDefaultFilterValues: IFilterGroup[] = [
	{
		title: STATUS,
		options: [
			{title: ALL_ATTENDEES, isSelected: true},
			{title: CHECKED_IN, isSelected: false},
			{title: NOT_CHECKED_IN, isSelected: false},
		],
	},
	{
		title: VIP_STATUS,
		options: [
			{title: TABLE_VIP_STATUS.ALL, isSelected: true},
			{title: TABLE_VIP_STATUS.ONLY_VIP, isSelected: false},
		],
	},
	{
		title: SPECIAL_MEAL,
		options: [
			{title: TABLE_SPECIAL_MEAL.ALL, isSelected: true},
			{title: TABLE_SPECIAL_MEAL.ONLY_SPECIAL_MEAL, isSelected: false},
		],
	},
	{
		title: TICKETS_TIERS,
		options: [{title: ALL_TICKETS_TIERS, isSelected: true, id: null}],
	},
];

export const attendeesDefaultFilterValuesMobile: IFilterGroup[] = [
	{
		title: STATUS,
		options: [
			{title: ALL_ATTENDEES, isSelected: true},
			{title: CHECKED_IN, isSelected: false},
			{title: PENDING, isSelected: false},
		],
	},
	{
		title: VIP_STATUS,
		options: [
			{title: TABLE_VIP_STATUS.ALL, isSelected: true},
			{title: TABLE_VIP_STATUS.ONLY_VIP, isSelected: false},
		],
	},
];

export const updateAttendeesFilterOptions = (ticketsTiers: IOrganizationTicketsTiers[], filterData: IFilterGroup[]) =>
	filterData.map((filterGroup) =>
		filterGroup.title === TICKETS_TIERS
			? {
					...filterGroup,
					options: [
						{
							title: ALL_TICKETS_TIERS,
							isSelected: !filterGroup.options.every((option) => !option.isSelected && option.id === null),
							id: null,
							isCheckBox: false,
						},
						...ticketsTiers.map((tier) => ({title: tier.name, isSelected: false, id: tier.id, isCheckBox: true})),
					],
			  }
			: filterGroup
	);

export const handleSetTierIds = (currentTierIds: number[] | null, id?: number) => {
	if (!id) return null;

	const isIdInTierIds = currentTierIds ? currentTierIds.includes(id) : false;

	if (isIdInTierIds) {
		const newTierIds = currentTierIds?.filter((tierId) => tierId !== id) || [];
		return newTierIds.length > 0 ? newTierIds : null;
	}
	return [...(currentTierIds || []), id];
};

export const getUpdatedFilterData = (
	currentFilterData: IFilterGroup[],
	groupTitle: string,
	optionTitle: string,
	selectedCheckboxId?: number | null
) => {
	const indexToUpdate = currentFilterData.findIndex((filterGroup) => filterGroup.title === groupTitle);

	return currentFilterData.map((filterGroup, index) => {
		if (index !== indexToUpdate) return filterGroup;

		switch (groupTitle) {
			case STATUS:
			case PAY_STATUS:
			case VIP_STATUS:
			case SPECIAL_MEAL:
				return {
					...filterGroup,
					options: filterGroup.options.map((option) => ({
						...option,
						isSelected: option.title === optionTitle,
					})),
				};

			case TICKETS_TIERS:
				const newOptions = filterGroup.options.map((option) => {
					if (option.isCheckBox && option.id === selectedCheckboxId) {
						return {
							...option,
							isSelected: !option.isSelected,
						};
					}
					return {
						...option,
					};
				});

				const hasSelectedCheckBox = newOptions.some((option) => option.isCheckBox && option.isSelected);

				const updatedOptions = newOptions.map((option) => {
					if ((!option.isCheckBox && hasSelectedCheckBox) || (option.isCheckBox && !hasSelectedCheckBox)) {
						return {
							...option,
							isSelected: false,
						};
					}

					if (!option.isCheckBox && !hasSelectedCheckBox) {
						return {
							...option,
							isSelected: true,
						};
					}

					return option;
				});

				return {
					...filterGroup,
					options: updatedOptions,
				};

			default:
				return filterGroup;
		}
	});
};

export const attendeesDefaultPaidStatusFilterValues: IFilterGroup[] = [
	{
		title: PAY_STATUS,
		options: [
			{title: ALL_ATTENDEES, isSelected: true},
			{title: PAID, isSelected: false},
			{title: PENDING, isSelected: false},
		],
	},
];
